import styles from "../styles/zipCodeComponent.module.css";
import axios from 'axios';
import { useState } from 'react';
import { Button, Form, InputGroup, ListGroup, Container, Row, Col } from 'react-bootstrap';


export const ZipCodeInputComponent = ({ zipCodes, setZipCodes }: {
    zipCodes: string[],
    setZipCodes: (zipCodes: string[]) => void
}) => {
    // const [zipCodes, setZipCodes] = useState<string[]>([]);
    const [input, setInput] = useState<string>('');
    const [userData, setUserData] = useState([]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInput(event.target.value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (['Enter', ',', ' '].includes(event.key)) {
            event.preventDefault();
            const trimmedInput = input.trim();
            if (trimmedInput && isValidZipCode(trimmedInput) && !zipCodes.includes(trimmedInput)) {
                setZipCodes([...zipCodes, trimmedInput]);
                setInput('');
            }
        }
    };

    const removeZipCode = (zip: string) => {
        setZipCodes(zipCodes.filter(z => z !== zip));
    };

    const isValidZipCode = (zip: string) => /^\d{5}$/.test(zip);

    const fetchData = async () => {
        if (zipCodes.length > 0) {
            try {
                const response = await axios.get('/api/users', { params: { zipCodes } });
                setUserData(response.data);
            } catch (error) {
                console.error('Failed to fetch data', error);
            }
        } else {
            alert('Please add at least one valid zip code.');
        }
    };

    return (
        <Container className="mt-4">
            <InputGroup className="mb-3">
                <Form.Control
                    type="text"
                    placeholder="Enter zip codes..."
                    value={input}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                />
                <Button variant="primary" onClick={fetchData}>Search</Button>
            </InputGroup>
            <ListGroup className="mb-3">
                {zipCodes.map(zip => (
                    <ListGroup.Item key={zip} className="d-flex justify-content-between align-items-center">
                        {zip}
                        <Button variant="outline-danger" size="sm" onClick={() => removeZipCode(zip)}>Remove</Button>
                    </ListGroup.Item>
                ))}
            </ListGroup>
            {userData.length > 0 && (
                <Row xs={1} md={2} lg={3}>
                    {userData.map((user: any) => (
                        <Col key={user.uid} className="mb-3">
                            <div className="p-3 border bg-light">
                                <h4>{user.username}</h4>
                                <p>Email: {user.email}</p>
                                <p>Zip Code: {user.homeZipCode}</p>
                                {/* Add more user details as needed */}
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};
